export const MOBILE = 600
export const TABLET = 900
export const LAPTOP = 1200

const Breakpoints = {
  mobile: `${MOBILE}px`,
  tablet: `${TABLET}px`,
  laptop: `${LAPTOP}px`,
}

export default Breakpoints
